<template>
  <v-row>
    <v-window
      v-model="window"
      :vertical="vertical"
      :show-arrows="showArrows"
      :reverse="reverse"
      show-arrows-on-hover
      dark
      continuous
      style="max-width:825px;"
    >
      <template v-for="adItem in adItems" >
        <v-window-item :key="adItem.id">
          <v-row >
            <template v-for="(content, index) in adItem.adItemContents">
              <v-col :key="index" >
                <v-menu top offset-y absolute style="max-width: 600px;">
                  <template v-slot:activator="{ on: menu, attrs }">
                    <v-tooltip left :disabled="!content.tooltip">
                      <template v-slot:activator="{ on: tooltip }">
                        <v-card
                          color="white"
                          :height="GetDimension(content.frontColumn,  IsVertical(adItem.adItemContents)).height"
                          :width="GetDimension(content.frontColumn,   IsVertical(adItem.adItemContents)).width"
                          v-bind="attrs"
                          v-on="{ ...tooltip, ...menu }"
                        >
                        <v-img
                          wigth="100%"
                          height="100%"
                          :src="content.sourceLink"
                          contain
                        ></v-img>
                        </v-card>
                      </template>
                      <span>{{content.tooltip}}</span>
                    </v-tooltip>
                  </template>
                  <v-list>
                    <v-list-item
                      v-for="(openType, index) in content.adItemContentOpens"
                      :key="index"
                      @click="AdItemContentOpen(openType)"
                    >
                      <v-list-item-title>{{ openType.adItemContentOpenType.type }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-col>
            </template>
          </v-row>
        </v-window-item>
      </template>
    </v-window>

    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline"></span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <iframe
                v-show="video.show"
                :src="video.src"
                frameborder="0"
                allowfullscreen
                width="600px"
                height="600px"
              ></iframe>
              <v-img v-show="image.show" :src="image.src"></v-img>
              <iframe
                width="100%"
                height="600px"
                frameborder="0"
                v-show="presentation.show"
                :src="presentation.src"
              ></iframe>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog = false">Закрыть</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
export default {
  props: {
    adLocation: Number,
    goodsId: Number,
  },
  data: () => ({
    dialog: false,
    window: 0,
    showArrows: true,
    vertical: true,
    reverse: true,
    autorun: true,
    video: { show: false, src: "" },
    image: { show: false, src: "" },
    presentation: { show: false, src: "" },
  }),

  methods: {  
     AdClick(openType) {
      let payload = {
        adItemContentId: openType.adItemContentOpenType,
        adItemContentOpenTypeId: openType.adItemContentOpenTypeId,
      };

      this.$store
      .dispatch("AD_CLICK", payload)
      .then(() => {
      })
      .catch((error) => {
        window.console.log(error);
      });
    },
    AdItemContentOpen(openType) {
      this.presentation.src = this.video.src = this.image.src = "";
      this.presentation.show = this.video.show = this.image.show = false;

      if (openType.adItemContentOpenType.id == 0) {
        let Search = {
          fullName: openType.sourceLink,
          beInThePrices: false,
          advanced: {
            INN: "",
            brand: "",
            ATC: "",
            producer: "",
            show: false,
          },
        };
        this.$store.commit("SET_GOODS_SEARCH", Search);
        if(this.$route.name != 'order')
            this.$router.push({path: '/order'})
      }

      if (openType.adItemContentOpenType.id == 1) {
        this.presentation.src =
          "https://docs.google.com/viewer?url=" +
          openType.sourceLink +
          "&embedded=true";
        this.presentation.show = true;
        this.dialog = true;
      }
      if (openType.adItemContentOpenType.id == 2) {
        this.video.src = openType.sourceLink;
        this.video.show = true;
        this.dialog = true;
      }
      if (openType.adItemContentOpenType.id == 3) {
        this.image.src = openType.sourceLink;
        this.image.show = true;
        this.dialog = true;
      }

      let payload = {
        adItemContentId: openType.adItemContentId,
        adItemContentOpenTypeId: openType.adItemContentOpenTypeId,
      };

      this.$store
      .dispatch("AD_CLICK", payload)
      .then(() => {
      })
      .catch((error) => {
        window.console.log(error);
      });
    },
    GetDimension(col, isVertical) {
      var dimension = this.$store.getters.AD_ITEM_CONTENT_DIMENSIONS(
        this.adLocation,
        col,
        isVertical
      );
      return dimension;
    },
    IsVertical(contents) {
      var result =
        contents
          .map((x) => x.frontColumn)
          .reduce(function (previousValue, currentValue) {
            return previousValue + currentValue;
          }) == 12;

      return result;
    },
   
  },
  mounted() {},
  computed: {
    ad: {
      get: function () {
        var result = this.$store.getters.ADS?.find(
          (x) => x.id == this.adLocation
        );
        return result;
      },
    },
    adItems: {
      get: function () {
        let result = this.ad?.adItems;

        if (this.goodsId != null){
          result = this.ad?.adItems?.filter((x) => x.goodsId == this.goodsId);
        }
        
        return result;
      },
    },
  },
  created() {
    setInterval(() => {
      if (!this.autorun) return;
      if (++this.window >= this.length) this.window = 0;
    }, 5000);
  },
};
</script>